import { DetailedHTMLProps, HTMLAttributes } from "react";

import { StyledContainer } from "@/components/shared/BackgroundGradient/styles";

export const BackgroundGradient = (
  props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
) => <StyledContainer {...props} />;
